import { useLocalStorage } from '@vueuse/core'

const isPwa = useLocalStorage('isPwa', false)

export function usePWA() {
  function checkPWA() {
    if (window.location.search.includes('pwa=1')) {
      isPwa.value = true
    }
  }

  return { isPwa, checkPWA }
}
